// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/driver_events.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Driver, DriverStatus } from "./driver_pb.js";
import { file_transportation_v1_driver } from "./driver_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/driver_events.proto.
 */
export const file_transportation_v1_driver_events: GenFile = /*@__PURE__*/
  fileDesc("CiV0cmFuc3BvcnRhdGlvbi92MS9kcml2ZXJfZXZlbnRzLnByb3RvEhF0cmFuc3BvcnRhdGlvbi52MSKLAgoLRHJpdmVyRXZlbnQSOAoHY3JlYXRlZBgBIAEoCzIlLnRyYW5zcG9ydGF0aW9uLnYxLkRyaXZlckNyZWF0ZWRFdmVudEgAEjgKB3VwZGF0ZWQYAiABKAsyJS50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXJVcGRhdGVkRXZlbnRIABI4CgdkZWxldGVkGAMgASgLMiUudHJhbnNwb3J0YXRpb24udjEuRHJpdmVyRGVsZXRlZEV2ZW50SAASRQoOc3RhdHVzX2NoYW5nZWQYBCABKAsyKy50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXJTdGF0dXNDaGFuZ2VkRXZlbnRIAEIHCgVldmVudCI/ChJEcml2ZXJDcmVhdGVkRXZlbnQSKQoGZHJpdmVyGAEgASgLMhkudHJhbnNwb3J0YXRpb24udjEuRHJpdmVyInsKEkRyaXZlclVwZGF0ZWRFdmVudBIyCg9wcmV2aW91c19kcml2ZXIYASABKAsyGS50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXISMQoOdXBkYXRlZF9kcml2ZXIYAiABKAsyGS50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXIiPwoSRHJpdmVyRGVsZXRlZEV2ZW50EikKBmRyaXZlchgBIAEoCzIZLnRyYW5zcG9ydGF0aW9uLnYxLkRyaXZlciK0AQoYRHJpdmVyU3RhdHVzQ2hhbmdlZEV2ZW50EikKBmRyaXZlchgBIAEoCzIZLnRyYW5zcG9ydGF0aW9uLnYxLkRyaXZlchI4Cg9wcmV2aW91c19zdGF0dXMYAiABKA4yHy50cmFuc3BvcnRhdGlvbi52MS5Ecml2ZXJTdGF0dXMSMwoKbmV3X3N0YXR1cxgDIAEoDjIfLnRyYW5zcG9ydGF0aW9uLnYxLkRyaXZlclN0YXR1c0JBWj9wYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS10cmFuc3BvcnRhdGlvbi9hcGkvdjE7dHJhbnNwb3J0YXRpb25fdjFiCGVkaXRpb25zcOgH", [file_transportation_v1_driver]);

/**
 * @generated from message transportation.v1.DriverEvent
 */
export type DriverEvent = Message<"transportation.v1.DriverEvent"> & {
  /**
   * @generated from oneof transportation.v1.DriverEvent.event
   */
  event: {
    /**
     * @generated from field: transportation.v1.DriverCreatedEvent created = 1;
     */
    value: DriverCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: transportation.v1.DriverUpdatedEvent updated = 2;
     */
    value: DriverUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: transportation.v1.DriverDeletedEvent deleted = 3;
     */
    value: DriverDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: transportation.v1.DriverStatusChangedEvent status_changed = 4;
     */
    value: DriverStatusChangedEvent;
    case: "statusChanged";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message transportation.v1.DriverEvent.
 * Use `create(DriverEventSchema)` to create a new message.
 */
export const DriverEventSchema: GenMessage<DriverEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_events, 0);

/**
 * @generated from message transportation.v1.DriverCreatedEvent
 */
export type DriverCreatedEvent = Message<"transportation.v1.DriverCreatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Driver driver = 1;
   */
  driver?: Driver;
};

/**
 * Describes the message transportation.v1.DriverCreatedEvent.
 * Use `create(DriverCreatedEventSchema)` to create a new message.
 */
export const DriverCreatedEventSchema: GenMessage<DriverCreatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_events, 1);

/**
 * @generated from message transportation.v1.DriverUpdatedEvent
 */
export type DriverUpdatedEvent = Message<"transportation.v1.DriverUpdatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Driver previous_driver = 1;
   */
  previousDriver?: Driver;

  /**
   * @generated from field: transportation.v1.Driver updated_driver = 2;
   */
  updatedDriver?: Driver;
};

/**
 * Describes the message transportation.v1.DriverUpdatedEvent.
 * Use `create(DriverUpdatedEventSchema)` to create a new message.
 */
export const DriverUpdatedEventSchema: GenMessage<DriverUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_events, 2);

/**
 * @generated from message transportation.v1.DriverDeletedEvent
 */
export type DriverDeletedEvent = Message<"transportation.v1.DriverDeletedEvent"> & {
  /**
   * @generated from field: transportation.v1.Driver driver = 1;
   */
  driver?: Driver;
};

/**
 * Describes the message transportation.v1.DriverDeletedEvent.
 * Use `create(DriverDeletedEventSchema)` to create a new message.
 */
export const DriverDeletedEventSchema: GenMessage<DriverDeletedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_events, 3);

/**
 * @generated from message transportation.v1.DriverStatusChangedEvent
 */
export type DriverStatusChangedEvent = Message<"transportation.v1.DriverStatusChangedEvent"> & {
  /**
   * @generated from field: transportation.v1.Driver driver = 1;
   */
  driver?: Driver;

  /**
   * @generated from field: transportation.v1.DriverStatus previous_status = 2;
   */
  previousStatus: DriverStatus;

  /**
   * @generated from field: transportation.v1.DriverStatus new_status = 3;
   */
  newStatus: DriverStatus;
};

/**
 * Describes the message transportation.v1.DriverStatusChangedEvent.
 * Use `create(DriverStatusChangedEventSchema)` to create a new message.
 */
export const DriverStatusChangedEventSchema: GenMessage<DriverStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver_events, 4);

